import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { SOURCE_WELCOME_CONFIG } from "../../config/sourceWelcome";
import { useWindows } from "../WindowManager";
import { QUICK_FILES } from "../fs";
import { PROFILE } from "../data";
import "./SourceToast.css";

const AUTO_DISMISS_MS = 14000;

export default function SourceToast({ ready }) {
  const { open } = useWindows();
  const [config, setConfig] = useState(null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!ready) return;
    const source = new URLSearchParams(window.location.search)
      .get("source")
      ?.toLowerCase();
    const match = source && SOURCE_WELCOME_CONFIG[source]?.toast;
    if (!match) return;
    const id = setTimeout(() => setConfig(match), 900);
    return () => clearTimeout(id);
  }, [ready]);

  useEffect(() => {
    if (!config) return;
    const id = setTimeout(() => setLeaving(true), AUTO_DISMISS_MS);
    return () => clearTimeout(id);
  }, [config]);

  useEffect(() => {
    if (!leaving) return;
    const id = setTimeout(() => setConfig(null), 300);
    return () => clearTimeout(id);
  }, [leaving]);

  if (!config) return null;

  const target = QUICK_FILES[config.target];

  return (
    <div
      className={`toast ${leaving ? "toast--leaving" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="toast__head">
        <img className="toast__avatar" src={PROFILE.avatar} alt="" />
        <span className="toast__app">{PROFILE.handle}</span>
        <button
          className="toast__close"
          onClick={() => setLeaving(true)}
          aria-label="Dismiss notification"
        >
          <X size={14} />
        </button>
      </div>
      <div className="toast__title">{config.title}</div>
      <p className="toast__text">{config.message}</p>
      {target && (
        <button
          className="win-btn win-btn--accent toast__action"
          onClick={() => {
            if (target.type === "file") {
              open(target.open.app, { fileId: target.id, ...target.open });
            } else {
              open("explorer", { folderId: target.id });
            }
            setLeaving(true);
          }}
        >
          {config.action}
        </button>
      )}
    </div>
  );
}
